import { render } from "./RatingComposition.vue?vue&type=template&id=ec9e2842"
import script from "./RatingComposition.vue?vue&type=script&lang=js"
export * from "./RatingComposition.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__